// src/config.js — single place for domain / URL configuration.
// Override via .env.local (dev) or .env.production (build). See .env.example.

const trimTrailingSlash = (url) => String(url || '').replace(/\/+$/, '');

const API_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_API_ORIGIN || 'https://papertrade.co.in'
);
const APP_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_APP_ORIGIN || 'https://app.papertrade.co.in'
);
const MLM_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_MLM_ORIGIN || 'https://bluerock.live'
);

const config = {
  API_ORIGIN,
  APP_ORIGIN,
  MLM_ORIGIN,

  // Legacy API (MLM pages, etc.)
  API_BASE_URL: `${API_ORIGIN}/api.php?table=`,

  // Secured React app API
  API_APP_BASE_URL: `${API_ORIGIN}/api_app.php?table=`,
  MEDIATOR_APP_URL: `${API_ORIGIN}/mediator_app.php`,
  APP_BASE_URL: `${API_ORIGIN}/`,

  // WebSocket feeds
  WS_ZERODHA_URL:
    process.env.REACT_APP_WS_ZERODHA_URL || 'wss://papertrade.co.in:8083',
  WS_GLOBAL_URL:
    process.env.REACT_APP_WS_GLOBAL_URL || 'wss://papertrade.co.in:8084',
  ALT_FEED_WS_URL:
    process.env.REACT_APP_ALT_FEED_WS_URL ||
    'wss://feed1.globalmarketcap.org/stream2/?access_token=crec4219d680f1d1ec480ef1685330a3',

  // Referral link base (register page on frontend domain)
  REFERRAL_REGISTER_PATH: '/register',
};

/** Full referral URL for a user id */
export function getReferralRegisterUrl(userId) {
  return `${config.APP_ORIGIN}${config.REFERRAL_REGISTER_PATH}?ud=${userId}`;
}

/** MLM report URL on the MLM domain */
export function getMlmReportUrl(path, { userId, userType, parentId }) {
  const base = trimTrailingSlash(config.MLM_ORIGIN);
  const params = new URLSearchParams({
    ud: String(userId),
    r: String(userType),
    mid: String(parentId),
  });
  return `${base}/${path.replace(/^\//, '')}?${params}`;
}

/** CSP connect-src values derived from config (production CSP in App.js) */
export function buildCspConnectSrc() {
  const sources = new Set(["'self'"]);

  const addOrigin = (rawUrl) => {
    if (!rawUrl) return;
    try {
      const url = new URL(rawUrl);
      sources.add(`${url.protocol}//${url.host}`);
      if (url.protocol === 'https:') {
        sources.add(`wss://${url.host}`);
      } else if (url.protocol === 'http:') {
        sources.add(`ws://${url.host}`);
      } else if (url.protocol === 'wss:' || url.protocol === 'ws:') {
        sources.add(`${url.protocol}//${url.host}`);
      }
    } catch {
      // ignore invalid URLs
    }
  };

  addOrigin(config.API_ORIGIN);
  addOrigin(config.WS_ZERODHA_URL);
  addOrigin(config.WS_GLOBAL_URL);
  addOrigin(config.ALT_FEED_WS_URL);

  return [...sources].join(' ');
}

export default config;
